
export enum ToastType {
  notset,
  createdGift,
  share,
  addedToCart,
  demoCtaDismissed,
  wishSent,
  guest
}



// WEBPACK FOOTER //
// ./src/app/toast/toast.enum.ts